import { CartOptional, CartProduct } from "../../store/interfaces/Cart";
import { ProductType } from "../enums/ProductType";
import { ProductItem } from "../types/ProductItem";
import { productHelper } from "./productHelper";

interface SelectedProductsProps {
  cartOptional: CartOptional;
  cartProduct: CartProduct;
}

const countSelectedProducts = ({
  cartOptional,
  cartProduct,
}: SelectedProductsProps): number => {
  let count = 0;
  count = cartProduct?.lowerBracket ? count + 1 : count;
  count = cartProduct?.machineFixing ? count + 1 : count;
  count = cartProduct?.tiltrotator ? count + 1 : count;
  count = cartProduct?.upperBracket ? count + 1 : count;
  count = cartProduct?.grappleModule ? count + 1 : count;
  count = cartProduct?.toolsProductItems
    ? count + cartProduct?.toolsProductItems.length
    : count;
  count = cartOptional?.toolsProductItems
    ? count + cartOptional?.toolsProductItems.length
    : count;
  count = cartOptional?.tiltrotator ? count + 1 : count;
  count = cartOptional?.machineFixing ? count + 1 : count;
  count = cartOptional?.grappleModule ? count + 1 : count;

  return count;
};

const getTools = (productItems: ProductItem[]) => {
  if (!productItems || productItems.length === 0) {
    return undefined;
  }

  let tools = {};

  productItems.forEach((productItem) => {
    const productType = productHelper.getToolsProductType(
      productItem.partNumber.key
    );

    switch (productType) {
      case ProductType.AsphaltCutters:
        tools = { ...tools, asphaltCutters: productItem };
        break;

      case ProductType.Buckets:
        tools = { ...tools, buckets: productItem };
        break;

      case ProductType.Compactors:
        tools = { ...tools, compactors: productItem };
        break;

      case ProductType.GradingBeams:
        tools = { ...tools, gradingBeams: productItem };
        break;

      case ProductType.Grapples:
        tools = { ...tools, grapples: productItem };
        break;

      case ProductType.GrappleModules:
        tools = { ...tools, grappleModules: productItem };
        break;

      case ProductType.RailGrapples:
        tools = { ...tools, railGrapples: productItem };
        break;

      case ProductType.Rippers:
        tools = { ...tools, rippers: productItem };
        break;
    }
  });

  return tools;
};

const getSelectedProductsJSON = ({
  cartOptional,
  cartProduct,
}: SelectedProductsProps) => {
  const productTools = getTools(cartProduct.toolsProductItems);
  const optionalTools = getTools(cartOptional.toolsProductItems);

  return {
    product: {
      ...(cartProduct.tiltrotator
        ? { tiltrotator: cartProduct.tiltrotator }
        : {}),
      ...(cartProduct.machineFixing
        ? { machineFixing: cartProduct.machineFixing }
        : {}),
      ...(cartProduct.upperBracket
        ? { upperBracket: cartProduct.upperBracket }
        : {}),
      ...(cartProduct.lowerBracket
        ? { lowerBracket: cartProduct.lowerBracket }
        : {}),
      ...(cartProduct.grappleModule
        ? { grappleModule: cartProduct.grappleModule }
        : {}),
      ...(productTools ? { tools: productTools } : {}),
    },
    optional: {
      ...(cartOptional.tiltrotator
        ? { tiltrotator: cartOptional.tiltrotator }
        : {}),
      ...(cartOptional.grappleModule
        ? { grappleModule: cartOptional.grappleModule }
        : {}),
      ...(cartOptional.machineFixing
        ? { machineFixing: cartOptional.machineFixing }
        : {}),
      ...(optionalTools ? { tools: optionalTools } : {}),
    },
  };
};

export const cartHelper = {
  countSelectedProducts,
  getSelectedProductsJSON,
};
